import Number from './number/EventPageNumberInitialState'

const { Record } = require('immutable')

export default Record({
    number: Number()
})